<template>
  <md-field>
    <label for="termo">Tipo</label>
    <md-select id="termo" v-model="value" name="termo" @md-selected="change">
      <md-optgroup label="Basicos">
        <md-option v-for="basico in basicos" :key="basico" :value="basico">
          {{ basico }}
        </md-option>
      </md-optgroup>

      <md-optgroup label="Funções">
        <md-option
          v-for="fun in funcoes"
          :key="fun.identificador"
          :value="fun.identificador"
        >
          {{ fun.text }}
        </md-option>
      </md-optgroup>
    </md-select>
  </md-field>
</template>

<script>
import { Termos, TipoTermo, TipoTermoString } from '@/utils/constants'

const termosFunc = Object.keys(Termos)
  .map((e) => Termos[e])
  .filter((e) => e.tipo === TipoTermo.Funcao)

export default {
  name: 'TermoTipo',
  props: ['termo'],
  data() {
    return {
      funcoes: termosFunc,
      basicos: ['Sensor', 'Valor', 'SensorVirtual'],
      tipoTermo: TipoTermo,
      value: null,
    }
  },
  beforeMount() {
    if (this.termo) {
      if (this.termo.tipo === TipoTermo.Funcao) {
        this.value = this.termo.identificador
      } else {
        this.value = TipoTermoString[this.termo.tipo]
      }
    }
  },
  methods: {
    change(e) {
      this.$emit('change', Termos[e])
    },
  },
}
</script>

<style scoped></style>
